

















































































import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { ApiRequest } from '@/types/request';
import { Vehicle } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ModelSelect } from 'vue-search-select';
// tslint:disable-next-line: no-var-requires
const VehicleMakes = require('../../config/vehicleMake.json');

@Component({
    mixins: [validationMixin],
     components: {
        ModelSelect,
    },
    props: {
        id: String,
    },
    data() {
        return {
            make: '',
            model: '',
            color: '',
            year: '',
            licenseNumberPlate: '',
            vehicleNo: '',
            equippedForWheelchair: '',
            equippedForStretcher: '',
            isYearValid: true,
            };
        },
    validations: {
        make: {
            required,
        },
        model: {
            required,
        },
        color: {
            required,
        },
        year: {
            required,
        },
        licenseNumberPlate: {
            required,
        },
        equippedForWheelchair: {
            required,
        },
        equippedForStretcher: {
            required,
        },
    },
})
export default class UpdateVehicleModal extends Vue {
    private show = false;
    private vehicle: Vehicle = {} as any;
    private makes = VehicleMakes;

    public mounted() {
        this.getVehicleDetails();
    }

      private async getVehicleDetails() {
        const vehicleId = this.$props.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_VEHICLE}/${vehicleId}`,
            loaderEvent: {
                show: true,
            },
        };
        const iHttpService = ObjectFactory.getHttpService();
        const response = await iHttpService.get<Vehicle>(apiRequest);
        if (response.success && response.data) {
            this.vehicle = response.data;
            this.$data.make = response.data.make;
            this.$data.model = response.data.model;
            this.$data.color = response.data.color;
            this.$data.year = response.data.year;
            this.$data.licenseNumberPlate = response.data.licenseNumberPlate;
            this.$data.vehicleNo = response.data.vehicleNo;
            this.$data.equippedForWheelchair = response.data.equippedForWheelchair;
            this.$data.equippedForStretcher = response.data.equippedForStretcher;
            this.show = true;
        } else {
            CommonUtils.showError(response);
        }
    }

    private async updateVehicle() {
        const iHttpService = ObjectFactory.getHttpService();
        const vehicleId = this.$props.id;
        const updateVehicleRequest: Vehicle = {
            make: this.$data.make,
            model: this.$data.model,
            color: this.$data.color,
            year: this.$data.year,
            licenseNumberPlate: this.$data.licenseNumberPlate,
            vehicleNo: this.$data.vehicleNo,
            equippedForWheelchair: this.$data.equippedForWheelchair,
            equippedForStretcher: this.$data.equippedForStretcher,
        };
        const apiRequest: ApiRequest = {
             baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_VEHICLE}/${vehicleId}`,
            data: updateVehicleRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<Vehicle>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_VEHICLE'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async validateYear() {
        this.$data.year = this.$data.year.replace(/\D/g, '').slice(0, 4);
        const currentYear = new Date().getFullYear();
        // tslint:disable-next-line:radix
        const enteredYear = parseInt(this.$data.year);
        if (isNaN(enteredYear) || enteredYear < 2000 || enteredYear > currentYear) {
            this.$data.isYearValid = false;
        } else {
            this.$data.isYearValid = true;
        }
    }

    private close() {
        this.$emit('close');
    }

}
